import { Drawer as AntdDrawer } from "../utils/local-antd";
import type { DrawerProps as AntdDrawerProps } from "../utils/local-antd";
import styled from "styled-components";

import { useTheme } from "../ThemeContext";
import i18n from "../i18n";
import { useAppDispatch } from "../redux/store";
import { appActions } from "../redux/app/app.slice";
import { AtiraIcon } from "./AtiraIcon";
import { faX } from "@fortawesome/free-solid-svg-icons/faX";
import { AppLangs } from "../model/shared/enum/AppLangs.enum";

type DrawerProps = AntdDrawerProps;

const StyledAntdDrawer = styled(AntdDrawer)`
  .ant-drawer-close {
    color: ${({ theme }) => theme.textColor};
  }

  .ant-drawer-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .ant-drawer-close:hover {
    color: ${({ theme }) => theme.gray};
  }
`;

type LocalDrawerProps = DrawerProps & {};

export const Drawer: React.FC<LocalDrawerProps> = ({
  children,
  open,
  ...props
}) => {
  const lang = i18n.language as AppLangs;
  const { theme } = useTheme();
  const dispatch = useAppDispatch();

  return (
    <StyledAntdDrawer
      placement={lang === AppLangs.AR ? "left" : "right"}
      open={open}
      closeIcon={<AtiraIcon icon={faX} size="1x" />}
      afterOpenChange={(isOpen) =>
        dispatch(appActions.setChatWidgetVisible(!isOpen))
      }
      {...props}
      title={props?.title}
      style={{ backgroundColor: theme.white, color: theme.textColor }}
      zIndex={props?.zIndex || 2000}
    >
      {children}
    </StyledAntdDrawer>
  );
};
